<template>
    <div class="news-preview-wrapper" v-if="currentNews">
        <div class="gradient"></div>
        <app-header :cover="[`/uploads/news/${currentNews.cover}`, 'image']" :texts="[currentNews.content.en.title]" :date="currentNews.date | formatDate" :footerMoreSpace="true"></app-header>
        <div class="news-preview-content">
            <div class="news-preview-content-div" v-if="currentNews.content.en.contentOne" v-html="currentNews.content.en.contentOne"></div>
            <div class="news-preview-gallery">
               <!-- PREV ARROW -->
                <div class="news-preview-gallery-controlls" @click="prevImage()" v-if="currentNews.gallery.length > 1">
                    <span class="alcomet">N</span>
                </div>
                <!-- IMAGE CONTAINER -->
                <div class="news-preview-gallery-image" v-if="currentNews.gallery.length > 0">
                  <div class="news-preview-gallery-image-counter">{{activeImage + 1}}/{{currentNews.gallery.length}}</div>
                  <transition-group mode="out-in" :name="slideDirection">
                    <!-- ALL IMAGES ABSOLUTELY POSITIONED ON TOP OF EACH OTHER -->
                    <div @click="toggleGallery()" v-show="index == activeImage" v-for="(image, index) in currentNews.gallery" :key="index" class="image" :style="{backgroundImage: 'url(/uploads/news/'+ image + ')'}"></div>
                  </transition-group>
                </div>
                <!-- NEXT ARROW -->
                <div class="news-preview-gallery-controlls" @click="nextImage()" v-if="currentNews.gallery.length > 1">
                  <span class="alcomet">O</span>
                </div>
            </div>
            <div class="news-preview-content-div" v-if="currentNews.content.en.contentTwo" v-html="currentNews.content.en.contentTwo"></div>
            <!-- <iframe class="youtube-video" width="560" height="315" src="https://www.youtube.com/embed/59PGRCmPtxI?rel=0&amp;showinfo=0" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe> -->
            <app-share-button></app-share-button>
        </div>
        <!-- Gallery -->
        <app-gallery v-if="isGalleryOpened" :prefix="'/uploads/news/'" :picturesArray="currentNews.gallery" :eventName="'close-news-preview-gallery'"></app-gallery>
    </div>
</template>

<script>
import Header from "../shared/Header";
import Gallery from "../shared/Gallery";
import ShareButton from "../shared/ShareButton";
export default {
  components: {
    appHeader: Header,
    appGallery: Gallery,
    appShareButton: ShareButton
  },
  data() {
    return {
      slideDirection: "slide-right",
      isGalleryOpened: false,
      activeImage: 0,
      currentNews: undefined
    };
  },
  watch: {
    $route(to, from) {
      this.findNews();
    }
  },
  mounted() {
    this.$eventHub.$on("close-news-preview-gallery", () => {
      this.isGalleryOpened = false;
    });
    this.findNews();
  },
  methods: {
    // Open/Close Gallery
    toggleGallery() {
      this.isGalleryOpened = this.isGalleryOpened == false ? true : false;
    },
    prevImage() {
      this.slideDirection = "slide-right";
      if (this.activeImage > 0) {
        this.activeImage--;
      } else {
        this.activeImage = this.currentNews.gallery.length - 1;
      }
    },
    nextImage() {
      this.slideDirection = "slide-left";
      if (this.activeImage < this.currentNews.gallery.length - 1) {
        this.activeImage++;
      } else {
        this.activeImage = 0;
      }
    },
    findNews() {
      this.$http
        .get(`${process.env.ROOT_API}/news/${this.$route.params.url}`)
        .then(response => {
          this.currentNews = response.data.news[0];
        })
        .catch(error => {
          // handle error
          this.currentNews = undefined;
          console.log(error);
        })
        .then(() => {
          // always executed
        });
    }
  },
  destroyed() {
    this.$eventHub.$off("close-news-preview-gallery");
  }
};
</script>

<style scoped>
.gradient {
  background: -moz-linear-gradient(
    top,
    rgba(0, 0, 0, 0.65) 0%,
    rgba(0, 0, 0, 0) 100%
  ); /* FF3.6-15 */
  background: -webkit-linear-gradient(
    top,
    rgba(0, 0, 0, 0.65) 0%,
    rgba(0, 0, 0, 0) 100%
  );
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.65) 0%,
    rgba(0, 0, 0, 0) 100%
  );
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#a6000000', endColorstr='#00000000',GradientType=0 );
  top: 0;
  height: 200px;
  position: absolute;
  width: 100%;
  z-index: 4;
}
/* CONTENT */
.news-preview-content {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
}
.news-preview-content-div {
  font-size: 20px;
  line-height: 36px;
  padding: 40px 0;
  text-align: justify;
  width: 47.5%;
}
.news-preview-content-div p {
  font-size: 20px;
  line-height: 36px;
  margin: 15px 0;
  text-align: justify;
  width: 100%;
}
.news-preview-gallery {
  align-items: center;
  display: flex;
  justify-content: space-around;
  width: 80%;
}
.news-preview-gallery-image {
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 6px;
  cursor: pointer;
  height: 750px;
  overflow: hidden;
  position: relative;
  width: 80%;
}
.image {
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}
.news-preview-gallery-controlls {
  align-items: center;
  background-color: rgba(255, 255, 255, 0.5);
  border: 1px solid #dde7ee;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  height: 50px;
  justify-content: center;
  margin: 5px 0;
  -webkit-transition: all 0.2s ease;
  -moz-transition: all 0.2s ease;
  -ms-transition: all 0.2s ease;
  -o-transition: all 0.2s ease;
  transition: all 0.2s ease;
  width: 50px;
}
.news-preview-gallery-controlls:hover {
  background-color: #dde7ee;
}
.news-preview-gallery-image-counter {
  background-color: rgba(255, 255, 255, 0.6);
  border-bottom-left-radius: 6px;
  padding: 5px 20px;
  position: absolute;
  right: 0;
  z-index: 1;
}

.news-preview-content p:last-child {
  display: flex;
  justify-content: flex-end;
  line-height: normal;
}
.news-share-btn {
  align-items: center;
  border: 1px solid #588cc1;
  border-radius: 30px;
  display: flex;
  font-size: 14px;
  font-weight: 700;
  justify-content: center;
  padding: 8px 20px;
  -webkit-transition: all 0.2s ease;
  -moz-transition: all 0.2s ease;
  -ms-transition: all 0.2s ease;
  -o-transition: all 0.2s ease;
  transition: all 0.2s ease;
  width: 110px;
}
.news-share-btn span {
  margin-right: 6px;
}
.news-share-btn:hover {
  background-color: #dde7ee;
}
.youtube-video {
  width: 40%;
}
.news-preview-content .share-btn-wrapper {
  width: 47.5%;
}
/* TRANSITIONS */
.slide-right-enter-active,
.slide-right-leave-active,
.slide-left-enter-active,
.slide-left-leave-active {
  transition: all 0.4s ease;
}
.slide-right-enter,
.slide-left-leave-to {
  transform: translateX(-100%);
}
.slide-right-leave-to,
.slide-left-enter {
  transform: translateX(100%);
}
@media screen and (max-width: 1600px) {
  .news-preview-gallery-image {
    height: 600px;
  }
  .news-preview-header-footer {
    padding: 0 40px;
  }
}
@media screen and (max-width: 1440px) {
  .news-preview-gallery-image {
    height: 500px;
  }
}
@media screen and (max-width: 1280px) {
  .news-preview-content-div {
    width: 60%;
  }
}
@media screen and (max-width: 1000px) {
  .gradient {
    height: 75px;
  }
  .news-preview-wrapper .header {
    height: 50vh;
  }
  .news-preview-content-div {
    width: 100%;
    padding-left: 30px;
    padding-right: 30px;
  }
  .news-preview-content {
    padding-bottom: 20px;
  }
  .news-preview-content p {
    font-size: 16px;
    margin: 15px 0;
    padding: 0 30px;
    width: 100%;
  }
  .news-preview-gallery {
    position: relative;
    width: 100%;
  }
  .news-preview-gallery-image {
    height: 60vw;
  }
  .news-preview-gallery-controlls {
    position: absolute;
    top: 50%;
    transform: translateY(-50%) translateX(-50%);
    left: 40px;
    z-index: 1;
  }
  .news-preview-gallery-controlls:last-child {
    left: initial;
    right: 40px;
    transform: translateY(-50%) translateX(50%);
  }
  .news-preview-content .share-btn-wrapper {
    width: 100%;
  }
}
@media screen and (max-width: 600px) {
  .news-preview-gallery-controlls {
    height: 40px;
    width: 40px;
  }
  .news-preview-gallery-controlls > span {
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/news/NewsPreview.vue